// File metadata helpers (Task 13.1 / 13.2).
//
// Derives the { format, sizeBytes } DocumentMeta shape the domain validators
// expect (ACCEPTED_DOCUMENT_FORMATS = PDF/JPEG/PNG) from a browser File, and
// formats human-readable byte sizes for inline upload feedback.

import type { DocumentMeta } from "./api";

const MIME_TO_FORMAT: Record<string, string> = {
  "application/pdf": "PDF",
  "image/jpeg": "JPEG",
  "image/jpg": "JPEG",
  "image/png": "PNG",
};

/** Map a File's MIME type (or extension) to an accepted document format. */
export function detectFormat(file: File): string {
  const byMime = MIME_TO_FORMAT[file.type.toLowerCase()];
  if (byMime) return byMime;
  const ext = file.name.split(".").pop()?.toLowerCase();
  if (ext === "pdf") return "PDF";
  if (ext === "jpeg" || ext === "jpg") return "JPEG";
  if (ext === "png") return "PNG";
  return file.type || (ext ?? "unknown");
}

export function toDocumentMeta(file: File): DocumentMeta {
  return { format: detectFormat(file), sizeBytes: file.size };
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
